import api from './api';

export type CanalCampanha = 'SMS' | 'EMAIL' | 'AMBOS';
export type StatusCampanhaComunicacao =
  | 'rascunho'
  | 'agendada'
  | 'a_enviar'
  | 'enviada'
  | 'falhou'
  | 'cancelada';

export interface FiltrosSegmentacao {
  tipo_conta?: 'all' | 'cliente' | 'entidade';
  perfil_codigos?: string[];
  apenas_opt_in?: boolean;
  user_ids?: string[];
}

export interface CampanhaComunicacao {
  ID_CAMPANHA: number;
  NOME: string;
  CANAL: CanalCampanha;
  STATUS: StatusCampanhaComunicacao;
  TEMPLATE_SMS_CODIGO: string | null;
  TEMPLATE_EMAIL_CODIGO: string | null;
  ASSUNTO_CUSTOM: string | null;
  CONTEUDO_CUSTOM: string | null;
  FILTROS: FiltrosSegmentacao | string | null;
  TOTAL_DESTINATARIOS: number;
  TOTAL_ENVIADOS: number;
  TOTAL_FALHOU: number;
  TOTAL_OPT_OUT_SKIPPED: number;
  CUSTO_ESTIMADO_CVE: number | null;
  AGENDADA_PARA: string | null;
  INICIADA_EM: string | null;
  CONCLUIDA_EM: string | null;
  CREATED_AT: string;
  UPDATED_AT: string;
}

export interface PreviewResult {
  total_destinatarios: number;
  sms_count: number;
  email_count: number;
  opt_out_skipped: number;
  custo_estimado_cve: number;
}

export interface CampanhaPayload {
  nome: string;
  canal: CanalCampanha;
  template_sms_codigo?: string;
  template_email_codigo?: string;
  assunto_custom?: string;
  conteudo_custom?: string;
  filtros?: FiltrosSegmentacao;
  agendada_para?: string;
}

class MarketingComunicacaoService {
  async setup() {
    await api.post('/admin/marketing/comunicacao/setup');
  }
  async list(): Promise<CampanhaComunicacao[]> {
    const res = await api.get<{ success: boolean; data?: CampanhaComunicacao[] }>(
      '/admin/marketing/comunicacao'
    );
    return res.data.data || [];
  }
  async get(id: number): Promise<CampanhaComunicacao & { progress?: Array<{ STATUS: string; n: number }> }> {
    const res = await api.get(`/admin/marketing/comunicacao/${id}`);
    return res.data.data;
  }
  async create(payload: CampanhaPayload): Promise<CampanhaComunicacao> {
    const res = await api.post('/admin/marketing/comunicacao', payload);
    return res.data.data;
  }
  async update(id: number, payload: Partial<CampanhaPayload>): Promise<void> {
    await api.put(`/admin/marketing/comunicacao/${id}`, payload);
  }
  async remove(id: number): Promise<void> {
    await api.delete(`/admin/marketing/comunicacao/${id}`);
  }
  async preview(id: number): Promise<PreviewResult> {
    const res = await api.post(`/admin/marketing/comunicacao/${id}/preview`);
    return res.data.data;
  }
  async test(id: number, target: { telefone?: string; email?: string }): Promise<any> {
    const res = await api.post(`/admin/marketing/comunicacao/${id}/test`, target);
    return res.data.data;
  }
  async send(id: number): Promise<PreviewResult> {
    const res = await api.post(`/admin/marketing/comunicacao/${id}/send`);
    return res.data.data;
  }
  async cancel(id: number): Promise<void> {
    await api.post(`/admin/marketing/comunicacao/${id}/cancel`);
  }
}

export default new MarketingComunicacaoService();
